import { render, staticRenderFns } from "./ForcCitationPerformanceComparison.vue?vue&type=template&id=299cd90e&"
import script from "./ForcCitationPerformanceComparison.vue?vue&type=script&lang=js&"
export * from "./ForcCitationPerformanceComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports